<template>
    <div class="modal-window mbs010 mbs024">
        <header class="modal-header">
            <div class="tit">과제보드에 입력된 내용이 안 보이는 현상이 나타날 경우</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>

        <div class="modal-content">
            <div class="info-txt">
                [ 조치방법 ]<br>
                F12 버튼 클릭<br>
                > 좌측 상단 새로고침 아이콘 마우스 우클릭<br>
                > ‘빈 캐시 및 하드 새로고침’ 또는 ‘캐시 비우기 및 강력 새로고침’ 클릭 <br>
                > 브라우저 모두 종료 후 재접속하여 확인<br>
            </div>
        </div>

        <footer class="modal-footer" style="height:30px;">
            <div class="txtr">
            <input type="checkbox" id="today" @change="closeEvent"><label for="today">일주일간 이 창을 열지 않음</label>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </div>
    </footer>
</div></template>

<script>
import { mapActions } from "vuex";

export default {
    props: {
        modalInfo: {
            type: Object,
            required: true,
        },
    },
    created() {
    },
    data() {
        return {}
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        closeEvent(){
            let obj = this;
            let reqData = {
                url : "/api/auth/org/changeNotiTypePopupStatus",
                method : "post",
                params: {},
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) =>{
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                    obj.$emit("close");
                } else {
                    obj.$emit("close");
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/NotiTypePopup.vue